import React from "react"
import { useTranslation } from "react-i18next"

import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { OverlayHeader } from "shared/ui/overlay/OverlayHeader"
import { OverlayWrapper } from "shared/ui/overlay/OverlayWrapper"

import { LoginOverlayProps } from "./LoginOverlay"

export const LoginOverlayView = React.memo(
  ({ loginAsEmployee, loginAsVisitor, onClose }: LoginOverlayProps) => {
    const { t } = useTranslation()
    return (
      <OverlayWrapper
        id="login-overlay"
        className="login-overlay"
        classNamePrefix="login-overlay"
      >
        <OverlayHeader.Container prefix="login-overlay" responsive={false}>
          <OverlayHeader.CloseButton onClick={onClose} className="secondary" />
          <OverlayHeader.Title>
            {t("Authentication.SignInSchakoNext")}
          </OverlayHeader.Title>
        </OverlayHeader.Container>
        <div className="login-overlay__content">
          {loginAsVisitor ? (
            <Button
              variant={ButtonVariant.PRIMARY}
              id="visitor-login-button"
              onClick={loginAsVisitor}
            >
              {t("Authentication.SignInOrSignUp")}
            </Button>
          ) : null}
          {loginAsEmployee ? (
            <Button
              variant={ButtonVariant.SECONDARY}
              id="employee-login-button"
              onClick={loginAsEmployee}
            >
              {t("Authentication.SignInAsSchakoEmployee")}
            </Button>
          ) : null}
        </div>
      </OverlayWrapper>
    )
  }
)
